<div class="credits-container" [ngClass]="{'showLoadingSpinner': showLoadingSpinner}">
    <div class="loading-spinner-container" *ngIf="showLoadingSpinner">
        <div class="tryb-design-spinner"></div>
    </div>
    <div class="credits-view-wrapper" #creditsViewWrapper>
        <div class="total">
            <span class="text">{{ 'user.userArea.credits.view.overall' | translate }}</span>
            <span class="amount">{{ formattedAmounts?.total }}</span>
        </div>
        <div class="budget-details" *ngIf="showInclusive || showExtra">
            <div class="inclusive"
                 *ngIf="showInclusive"
                 [class.no-text]="!showInclusiveText"
                 [style.width.%]="inclusiveWidth"
                 [title]="'user.userArea.credits.tooltips.inclusive' | translate">
                <span class="text"
                      *ngIf="showInclusiveText">{{ 'user.userArea.credits.view.inclusive' | translate }}</span>
                <span class="amount">{{ formattedAmounts?.inclusive }}</span>
            </div>
            <div class="extra"
                 *ngIf="showExtra"
                 [class.no-text]="showExtra && !showExtraText"
                 [style.width.%]="extraWidth"
                 [title]="'user.userArea.credits.tooltips.extra' | translate">
                <span class="text"
                      *ngIf="showExtraText">{{ 'user.userArea.credits.view.extra' | translate }}</span>
                <span class="amount">{{ formattedAmounts?.extra }}</span>
            </div>
        </div>
        <div class="usage-details">
            <div class="used"
                 *ngIf="showUsed"
                 [class.no-text]="showUsed && !showUsedText"
                 [title]="'user.userArea.credits.tooltips.used' | translate"
                 [style.width.%]="usedWidth">
                <span class="text"
                      *ngIf="showUsedText">{{ 'user.userArea.credits.view.used' | translate }}</span>
                <span class="amount">{{ formattedAmounts?.used }}</span>
            </div>
            <div class="blocked"
                 *ngIf="showBlocked"
                 [class.no-text]="showBlocked && !showBlockedText"
                 [style.width.%]="blockedWidth"
                 [title]="'user.userArea.credits.tooltips.blocked' | translate">
                <span class="text"
                      *ngIf="showBlockedText">{{ 'user.userArea.credits.view.blocked' | translate }}</span>
                <span class="amount">{{ formattedAmounts?.blocked }}</span>
            </div>
            <div class="available" [style.width.%]="availableWidth"
                 [title]="'user.userArea.credits.tooltips.available' | translate"
                 [class.no-text]="!showAvailableText">
                <span class="text"
                      *ngIf="showAvailableText">{{ 'user.userArea.credits.view.available' | translate }}</span>
                <span class="amount">{{ formattedAmounts?.available }}</span>
            </div>
        </div>
    </div>
    <div class="credits-explanation-and-buttons-wrapper">
        <div class="credits-explanation-container">
            <a href="https://www.tryb.ai/credits" target="_blank" rel="noopener noreferrer">
                <span class="credits-explanation">
                    <img src="assets/svg/reusable-svg/credit-character.svg" alt="credit-character">&nbsp;
                    <span>{{ 'shared.components.subscriptionsPage.components.subscriptions.infoTexts.creditsExplanation' | translate }}</span>
                </span>
            </a>
        </div>
        <div class="buttons-container">
            <div class="button" id="change-subscription-button"
                 (click)="changeSubscriptionClicked.emit()">
                <span>{{ 'user.userArea.credits.buttons.changeSubscription' | translate }}</span>
            </div>
        </div>
    </div>
    <div class="info-wrapper">
        <img src="assets/svg/user-area/bell.svg" alt="bell">
        <span>{{
                getAvailabilityText() | translate: { date: periodEndDate | date : dateFormat : '' : 'en-En' }
            }}</span>
    </div>
</div>
